<template>
  <div>
    <div id="north">
      <header-info cur="6"></header-info>
    </div>
    <div id="menu"></div>
    <div id="center">
      <div class="content">
        <ul class="action">
          <li
            :class="isActive==1?'active':''"
            @click="changeActive(1)"
          >评分排行</li>
          <li
            :class="isActive==2?'active':''"
            @click="changeActive(2)"
          >热门排行</li>
          <li
            :class="isActive==3?'active':''"
            @click="changeActive(3)"
          >收藏排行</li>
          <li
            :class="isActive==4?'active':''"
            @click="changeActive(4)"
          >学科分类</li>
        </ul>
        <ul
          class="rank-toggle"
          v-show="isActive!=4"
        >
          <li
            :class="queryInfo.time_type=='month'?'active':''"
            @click="toggleTimeType('month')"
          >月排行</li>
          <li
            :class="queryInfo.time_type=='all'?'active':''"
            @click="toggleTimeType('all')"
          >总排行</li>
        </ul>
        <ul
          class="rank-list"
          :style="isActive!=4?'':'margin-top:30px'"
        >
          <li
            v-for="(item,index) in listData"
            :key="item.id"
          >
            <span class="num">{{index+1}}</span>
            <div
              class="rank-img"
              v-show="isActive!=4"
            >
              <img
                :src="item.logo"
                :onerror="$store.state.defaultImg"
                alt=""
              >
            </div>
            <div class="title">
              <span>{{item.title?item.title:'--'}}</span>
            </div>
            <span
              class="person"
              v-show="isActive!=4"
            >负责人：{{item.master_name?item.master_name:'--'}}</span>
            <span
              class="person"
              v-show="isActive!=4"
            >所属学校：{{item.school_title?item.school_title:'--'}}</span>
            <span
              class="person"
              v-show="isActive==4"
            >实验数：{{item.exp_count?item.exp_count:'--'}}</span>
            <div class="grade">
              <span v-if="isActive==1">评分</span>
              <span v-if="isActive==4 || isActive==2">实验人次</span>
              <span v-if="isActive==3">收藏数</span>
              <span v-if="isActive==1">{{item.avg_grade? parseFloat(item.avg_grade).toFixed(1) :'--'}}</span>
              <span v-if="isActive==3">{{item.collect_count?item.collect_count:'--'}}</span>
              <span v-if="isActive==4 || isActive==2">{{item.student_count?item.student_count:'--'}}</span>
            </div>
          </li>
        </ul>
        <div
          class="view-more"
          @click="getMore"
          v-if="listData.length==10"
        >查看更多</div>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'

export default {
  name: 'Search',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      isActive: 1,
      queryInfo: {
        time_type: 'month',
        size: 10
      },
      listData: []
    }
  },

  methods: {
    changeActive(val) {
      this.isActive = val
      if (!this.queryInfo.time_type) {
        this.queryInfo.time_type = 'month'
      }
      this.getRankInfo()
    },
    toggleTimeType(val) {
      this.queryInfo.time_type = val
      this.getRankInfo()
    },
    async getRankInfo() {
      let url
      if (this.isActive === 1) {
        url = '/ordering_appraise/'
      } else if (this.isActive === 2) {
        url = '/ordering_student/'
      } else if (this.isActive === 3) {
        url = '/ordering_collect/'
      } else if (this.isActive === 4) {
        url = '/ordering_subjectcategory/'
        this.queryInfo.time_type = undefined
      }
      await this.$http.get(url, {
        params: this.queryInfo
      }).then((data) => {
        this.listData = data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    getMore() {
      this.queryInfo.size = 20
      this.getRankInfo()
    }
  },
  mounted() {
    this.getRankInfo()
  }
}
</script>

<style lang="less" scoped>
#center {
  background: #E9F8F6;
}
.action {
  width: 100%;
  height: 104px;
  background: url(../../../assets/images/bg.jpg) no-repeat;
  background-size: 100% auto;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  li {
    margin-right: 75px;
    font-size: 22px;
    color: #2f4662;
    line-height: 100px;
    cursor: pointer;
    border-bottom: 4px solid transparent;
    &.active {
      color: #222222;
      border-bottom: 4px solid #4f86fb;
    }
  }
}
.rank-toggle {
  width: 180px;
  height: 40px;
  margin: 40px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 5px solid #fff;
  li {
    width: 90px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #4a5f7a;
    background: #e6edf6;
    cursor: pointer;
    &.active {
      background: #6f85a2;
      color: #fff;
    }
  }
}
.rank-list {
  width: 1200px;
  margin: 0 auto 20px;
  li {
    height: 105px;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    .num {
      width: 29px;
      height: 29px;
      color: #fff;
      background: #999999;
      text-align: center;
      line-height: 29px;
      margin-left: 20px;
    }
    .rank-img {
      width: 108px;
      height: 68px;
      margin-left: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      flex: 1;
      font-size: 16px;
      color: #222;
      font-weight: bold;
      margin-left: 20px;
      margin-right: 100px;
      span {
        display: block;
      }
    }
    .person {
      flex: 1;
      font-size: 16px;
      color: #555555;
    }
    .grade {
      width: 160px;
      height: 80%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-left: 1px solid #ebeff7;
      margin-left: 20px;

      span {
        font-size: 16px;
        color: #666666;
        display: inline-block;
        &:last-child {
          color: #dc2f2f;
          font-size: 22px;
          font-weight: bold;
          margin-top: 10px;
        }
      }
    }
    &:first-child {
      .num {
        background: #ff2703;
      }
    }
    &:nth-child(2) {
      .num {
        background: #ff8503;
      }
    }
    &:nth-child(3) {
      .num {
        background: #ffc103;
      }
    }
  }
}
.view-more {
  width: 142px;
  height: 50px;
  font-size: 18px;
  color: #759dce;
  line-height: 50px;
  text-align: center;
  margin: 0 auto 30px;
  cursor: pointer;
  border: 1px solid #759dce;
}
</style>
